
export const url = 'https://fx.fxzb.vip/admin'
// export const url = 'https://bailin.fxzb.cn'
// export const url = 'https://dev.fx.fxzb.vip/admin'
// export const url = 'http://192.168.110.160:8905'

//京东商家id
// 线上
export const JdKeeperId = 'ff8080818c170b3d0181c3ae778285f91'
// dev环境
// export const JdKeeperId = 'ff8080818bd8d452018bd92cc9470027'
// 本地环境
// export const JdKeeperId = '2c9082718be19cab018be1e95dd50042'

// export const proApiUrl = '//dev.fx.api.fxzb.vip/';
export const proApiUrl = '//fx.api.fxzb.vip/';
// export const proApiUrl = 'http://192.168.110.201:8102/'
// export const proApiUrl = 'http://192.168.110.48:8128/'

// 注册授权小程序域名地址
// dev环境
// export const zcHttps = 'http://dev.sj.fxzb.vip/#/'
// 线上环境
export const zcHttps = 'https://fx.fxzb.vip/admin/#/'


import { export_json_to_excel } from "../utils/excel/Export2Excel.js";
export function leaveOut(text) {
    return text.substring(0, 10) + '···' + text.substring(text.length - 10)
}
export function currentUrlToParams(key = null) {
    let paramsUrl = (window.location.href).split('?');
    if (paramsUrl.length < 2) return key ? null : {};
    let paramsArr = paramsUrl[1].split('&');
    let paramsData = {}
    paramsArr.forEach(r => {
        let data = r.split('=')
        paramsData[data[0]] = data[1]
    })
    if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null;
    return paramsData;
}

export function clone(obj) {
    let strData = JSON.stringify(obj)
    return JSON.parse(strData);
}

export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.ceil(n * k) / k;
        };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

//时间戳转换方法    date:时间戳数字
export function format_datestr(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD + " " + hh + mm;
}


//时间戳转换方法    date:时间戳数字
export function format_datestrCC(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD
}

//时间戳转换方法    date:时间戳数字
export function format_datestrss(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';;
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return MM + DD + " " + hh + mm + ss;
}

//时间戳转换方法    date:时间戳数字
export function format_date_ymd(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    return YY + MM + DD;
}

export function getNextDate(date, day) {
    var dd = new Date(date);
    dd.setDate(dd.getDate() + day);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    return y + "-" + m + "-" + d;
}

// 计算两个时间差 dateBegin 开始时间
export function timeFn(dateBegin) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date();//获取当前时间
    var dateDiff = dateBegin - dateEnd.getTime();//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}

// 计算两个时间差 dateBegin 开始时间
export function timetwo(dateend) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date();//获取当前时间
    var dateDiff = dateEnd.getTime() - dateend;//时间差的毫秒数

    console.log('dateend', dateend)
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}


// 计算两个时间差 dateBegin 开始时间
export function time_cz(start_time, end_time) {
    var dateDiff = end_time - start_time;//时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))//计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))//计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000)      //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}
/** 导出Excel */
export function explor_excel(header, filterData, excelData, name) {
    require.ensure([], () => {
        // that.excelData为传入的数据
        const data = formatJson(filterData, excelData);
        export_json_to_excel(header, data, name); // 导出的表格名称，根据需要自己命名
    });
}

function formatJson(filterVal, jsonData) {
    return jsonData.map((v) => filterVal.map((j) => v[j]));
}

//根据两个值计算折扣
export function getDiscount(price, prices) {
    return (price / prices * 10).toFixed(2)
}
//商品数据来源处理
export function originData(origin) {
    let text = ''
    if (origin == 'Lianlian') {
        text = '联'
    } else if (origin == 'LocalShop') {
        text = '自'
    }
    return text
}
// 获取几天后的时间
export function getDateAfter(time, n, takeTime) {// n为多少天，-代表往前，+代表往后
    let date1 = new Date(time)
    console.log(date1, 'date1')
    // let time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();//time1表示当前时间
    let date2 = new Date(date1);
    console.log(date2, 'date2')
    date2.setDate(date1.getDate() + (n - 1));
    let time2 = date2.getFullYear() + "-" + ("0" + (date2.getMonth() + 1)).slice(-2) + "-" + ("0" + date2.getDate()).slice(-2) + ' ' + takeTime;
    console.log(time2, 'time2')
    return new Date(time2).getTime()
}
export function treeData(data, list) {
    for (let i of list) {
        let array = data.filter(item => {
            let code = new RegExp(i.code + "-([a-zA-Z0-9]+)$")
            return code.test(item.code);
        })
        if (array.length > 0) {
            i.children = array
            treeData(data, array)
        }
    }
    return list[0].children;
}
//城市数据格式
export function cityData(list) {
    console.log(list, 'list')
    let cityList = []
    list.map(item => {
        if (item.level == 'province') {
            cityList.push({
                value: item.code,
                label: item.name,
                children: []
            })
        }
    })
    list.map(item => {
        // && (i.value.substring(0, 2) == item.code.substring(0, 2)) && (i.value != item.code)
        cityList.map(i => {
            if (item.level == 'city' && (i.value.substring(0, 2) == item.code.substring(0, 2))) {
                i.children.push({
                    value: item.code,
                    label: item.name,
                    num: item.num
                })
            }
        })
    })
    return cityList;
}
//城市数据格式
export function wxCityData(list) {
    console.log(list, 'list')
    let cityList = []
    list.map(item => {
        if (item.level == 1) {
            cityList.push({
                value: item.code,
                label: item.name,
                level: item.level,
                children: []
            })
        }
    })
    list.map(item => {
        cityList.map(i => {
            if (item.level == 2 && (i.value == item.parentCode)) {
                i.children.push({
                    value: item.code,
                    label: item.name,
                    level: item.level,
                    children: []
                })
            }
        })
    })
    list.map(item => {
        cityList.map(i => {
            i.children.map(j =>{
                if (item.level == 3 && (j.value == item.parentCode)) {
                    j.children.push({
                        value: item.code,
                        label: item.name,
                        level: item.level,
                    })
                }
            })
        })
    })
    return cityList;
}
//去8个字母数字组合
export function random() {
    let str = ""
    let array = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
    ];
    for (let i = 0; i < 8; i++) {
        str +=
            array[Math.round(Math.random() * (array.length - 1))];
    }
    return str
}
//时间戳转换方法    date:时间戳数字
export function format_ymd(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD;
}
/**将数组中具有相同值的对象 取出组成新的数组 */
export function sortArr(arr, str) {
    console.log(JSON.parse(JSON.stringify(arr)), str)
    let _arr = [],
        _t = [],
        // 临时的变量
        _tmp

    // 按照特定的参数将数组排序将具有相同值得排在一起
    arr = arr.sort(function (a, b) {
        const s = a[str],
            t = b[str]
        return s < t ? -1 : 1
    })
    if (arr.length) {
        _tmp = arr[0][str]
    }
    for (const i in arr) {
        if (arr[i][str] === _tmp) {
            _t.push(arr[i])
        } else {
            _tmp = arr[i][str]
            _arr.push(_t)
            _t = [arr[i]]
        }
    }
    // 将最后的内容推出新数组
    _arr.push(_t)
    return _arr
}
export function getNy() {
    // 创建当前日期对象
    var currentDate = new Date();

    // 定义存放结果数组
    var resultArray = [];
    for (let i = 0; i < 3; i++) {
        // 设置日期为当前日期减去i个月
        var date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);

        // 将日期转换成指定格式（YYYY-MM）并添加到结果数组中
        var formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        resultArray.push({
            label: formattedDate,
            value: formattedDate
        });
    }
    return resultArray
}

// 处理影票规则数据
export function handlerMovieRuleData(settingData, id) {
    // console.log(settingData,'settingData')
    let settingList = settingData.map((item, index) => {
        return {
            // 城市、影院、影厅、电影、院线 设置为对象
            mianSetting: JSON.stringify({
                // 城市
                cityCode: item.cityCode?item.cityCode:'',
                excludeCityCode: item.excludeCityCode?item.excludeCityCode:'',
                cityName: item.cityName?item.cityName:'',
                excludeCityName: item.excludeCityName?item.excludeCityName:'',

                cityNameArr: item.cityName ? item.cityName.split(',') : [],
                excludeCityNameArr: item.excludeCityName ? item.excludeCityName.split(',') : [],
                cityCodeArr: item.cityName ? item.cityCode.split(',') : [],
                excludeCityCodeArr: item.excludeCityCode ? item.excludeCityCode.split(',') : [],

                // 院线
                cinemaLineId: item.cinemaLineId,
                excludeCinemaLineId: item.excludeCinemaLineId,
                cinemaLineName: item.cinemaLineName,
                excludeCinemaLineName: item.excludeCinemaLineName,
                cinemaLineIdArr: item.cinemaLineId ? item.cinemaLineId.split(',') : [],
                excludeCinemaLineIdArr: item.excludeCinemaLineId ? item.excludeCinemaLineId.split(',') : [],

                // 影院
                cinemaKeyword: item.cinemaKeyword,
                excludeCinemaKeyword: item.excludeCinemaKeyword,
                cinemaKeywordArr: item.cinemaKeyword ? item.cinemaKeyword.split(',') : [],
                excludeCinemaKeywordArr: item.excludeCinemaKeyword ? item.excludeCinemaKeyword.split(',') : [],

                // 电影
                movieKeyword: item.movieKeyword,
                excludeMovieKeyword: item.excludeMovieKeyword,
                movieKeywordArr: item.movieKeyword ? item.movieKeyword.split(',') : [],
                excludeMovieKeywordArr: item.excludeMovieKeyword ? item.excludeMovieKeyword.split(',') : [],

                // 影厅
                hallKeyword: item.hallKeyword,
                excludeHallKeyword: item.excludeHallKeyword,
                hallKeywordArr: item.hallKeyword ? item.hallKeyword.split(',') : [],
                excludeHallKeywordArr: item.excludeHallKeyword ? item.excludeHallKeyword.split(',') : [],

                // showCity: false,
                // showBrand: false,
                // showShop: false,
                showCity: false,
                showLine: false,
                showCinema: false,
                showMovie: false,
                showHall: false,
            }),
            // 价格区间
            maxOriginPrice: item.maxOriginPrice,
            minOriginPrice: item.minOriginPrice,
            //  id
            id: item.id,
            // 排序
            priceIndex: item.priceIndex,
            // 接单价
            bidTakePrice: item.bidTakePrice,
            // 销售价
            selfPrice: item.selfPrice,
            cardPrice: item.cardPrice,
        }
    });
    var mianSetObj = {};
    // 找出 mianSetting 中的重复对象
    let mianSettings = settingList.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.mianSetting]) {
            mianSetObj[next.mianSetting] = true;
            cur.push(next.mianSetting)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur;
    }, []);

    // 设置值
    mianSettings = mianSettings.map(item => {
        let otherSettingData = [];
        settingList.forEach(set => {
            if (item == set.mianSetting) {
                otherSettingData.push({
                    // 价格区间
                    maxOriginPrice: set.maxOriginPrice,
                    minOriginPrice: set.minOriginPrice,
                    // 接单价
                    bidTakePrice: set.bidTakePrice,
                    minBidTakeDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.bidTakePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxBidTakeDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.bidTakePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    // 销售价
                    channelSalePrice: set.channelSalePrice,
                    minSaleDiscount: set.minOriginPrice > 0 ? ((set.minOriginPrice - Math.abs(set.channelSalePrice)) / set.minOriginPrice * 10).toFixed(2) : 0,
                    maxSaleDiscount: set.maxOriginPrice > 0 ? ((set.maxOriginPrice - Math.abs(set.channelSalePrice)) / set.maxOriginPrice * 10).toFixed(2) : 0,
                    //  id
                    id: set.id,
                    // 排序
                    priceIndex: set.priceIndex,
                    selfPrice: set.selfPrice,
                    cardPrice: set.cardPrice,
                })
            }
        })
        return {
            mianSetting: JSON.parse(item),
            otherSettingData: otherSettingData,
        };
    })
    console.log(mianSettings)
    return mianSettings;
}


// 分解得到提交的数据
export function decomposeMovieRuleData(cities, lines, mianSettings) {

    let sub_movie_rule_data = [];
    mianSettings.map(set => {
        // 循环价格的数据
        set.otherSettingData.forEach(other_set => {
            sub_movie_rule_data.push({
                // 城市
                cityName: set.mianSetting.cityNameArr.length > 0 ? set.mianSetting.cityNameArr.toString() : '',
                excludeCityName: set.mianSetting.excludeCityNameArr.length > 0 ? set.mianSetting.excludeCityNameArr.toString() : '',

                cityCode: getCityCodeString(cities, set.mianSetting.cityNameArr),
                excludeCityCode: getCityNameString(cities, set.mianSetting.excludeCityNameArr),

                // 院线
                cinemaLineId: set.mianSetting.cinemaLineIdArr.length > 0 ? set.mianSetting.cinemaLineIdArr.toString() : '',
                excludeCinemaLineId: set.mianSetting.excludeCinemaLineIdArr.length > 0 ? set.mianSetting.excludeCinemaLineIdArr.toString() : '',
                cinemaLineName: getLineNameString(lines, set.mianSetting.cinemaLineIdArr),
                excludeCinemaLineName: getLineNameString(lines, set.mianSetting.excludeCinemaLineIdArr),

                // 影院
                cinemaKeyword: set.mianSetting.cinemaKeywordArr.length > 0 ? set.mianSetting.cinemaKeywordArr.toString() : '',
                excludeCinemaKeyword: set.mianSetting.excludeCinemaKeywordArr.length > 0 ? set.mianSetting.excludeCinemaKeywordArr.toString() : '',

                // 电影
                movieKeyword: set.mianSetting.movieKeywordArr.length > 0 ? set.mianSetting.movieKeywordArr.toString() : '',
                excludeMovieKeyword: set.mianSetting.excludeMovieKeyword.length > 0 ? set.mianSetting.excludeMovieKeyword.toString() : '',

                // 影厅
                hallKeyword: set.mianSetting.hallKeywordArr.length > 0 ? set.mianSetting.hallKeywordArr.toString() : '',
                excludeHallKeyword: set.mianSetting.excludeHallKeywordArr.length > 0 ? set.mianSetting.excludeHallKeywordArr.toString() : '',

                // 价格区间
                maxOriginPrice: other_set.maxOriginPrice,
                minOriginPrice: other_set.minOriginPrice,
                // 接单价
                bidTakePrice: other_set.bidTakePrice,
                // 自主出票价
                selfPrice: other_set.selfPrice,
                cardPrice: other_set.cardPrice,
                //  id
                id: other_set.id,
                // 排序
                priceIndex: other_set.priceIndex,
            })
        })
    })
    return sub_movie_rule_data;
}

// 根据code 获取到 name
function getCityNameString(originalCityData, codes) {
    let names = [];
    codes.forEach(code => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityCode == code;
        });
        if (city) {
            names.push(city.cityName);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 根据code 获取到 name
function getCityCodeString(originalCityData, names) {
    let codes = [];
    names.forEach(name => {
        let city = originalCityData.find(city_obj => {
            return city_obj.cityName == name;
        });
        if (city) {
            codes.push(city.cityCode);
        }
    })
    return codes.length > 0 ? codes.toString() : '';
}

// [院线]根据id 获取到 name
function getLineNameString(lineData, ids) {
    let names = [];
    ids.forEach(id => {
        let line_obj = lineData.find(line => {
            return line.id == id;
        })
        if (line_obj) {
            names.push(line_obj.name);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 【品牌】根据id 获取到 name
function getBrandNameString(brands, ids) {
    let names = [];
    ids.forEach(id => {
        let brand = brands.find(line => {
            return line.id == id;
        })
        if (brand) {
            names.push(brand.name);
        }
    })
    return names.length > 0 ? names.toString() : '';
}

// 【店铺】
function getShopIdAndName(idNameArr) {
    let backData = {
        ids: [],
        names: []
    };
    (idNameArr || []).forEach(id_name => {
        let id_names = id_name.split('ぁ');
        backData.ids.push(id_names[0]);
        backData.names.push(id_names[1]);
    })
    if (backData.ids.length == 0) {
        backData.ids = '';
    }
    if (backData.names.length == 0) {
        backData.names = '';
    }
    backData.ids = backData.ids.toString();
    backData.names = backData.names.toString();
    return backData;
}
// 处理精度问题
export function signFigures(num, rank = 6) {
    if (!num) return (0)
    const sign = num / Math.abs(num)
    const number = num * sign
    const temp = rank - 1 - Math.floor(Math.log10(number))
    let ans
    if (temp > 0) {
        ans = parseFloat(number.toFixed(temp))
    } else if (temp < 0) {
        ans = Math.round(number / Math.pow(10, temp)) * temp
    } else {
        ans = Math.round(number)
    }
    return (ans * sign)
}
export function toRate(rate) {
    let data = parseFloat(rate);
    return ((data >= 1 ? data : data * 10).toString().replace('.', '') + '0000').substring(0, 4)
}
//本地生活优惠券规则数据分解
export function handlerLocalRuleData(mianSettings, type) {
    let list = []
    mianSettings.map(item => {
        let cNameArr = [];
        let eNameArr = [];
        /**  包含城市 */
        if (item.includeCityNames && item.includeCityCodes) {
            let nameArr = item.includeCityNames
            let codeArr = item.includeCityCodes
            nameArr.forEach((item, index) => {
                cNameArr.push(codeArr[index] + "-" + item);
            });
        }
        /**  不包含城市 */
        if (item.excludeCityNames && item.excludeCityCodes) {
            let nameEArr = item.excludeCityNames
            let codeEArr = item.excludeCityCodes
            nameEArr.forEach((item, index) => {
                eNameArr.push(codeEArr[index] + "-" + item);
            });
        }
        item.cityNameArr = cNameArr;
        item.excludeCityNameArr = eNameArr;
        let shopKeeperList = []
        if (item.includeShopKeeperIds) {
            item.includeShopKeeperIds.map((i, inx) => {
                shopKeeperList.push({
                    shopName: item.includeShopKeeperNames && item.includeShopKeeperNames.length ? item.includeShopKeeperNames[inx] : '',
                    shopKeeperId: i
                })
            })
        }
        let shopKeeperLists = []
        if (item.excludeShopKeeperIds) {
            item.excludeShopKeeperIds.map((i, inx) => {
                shopKeeperLists.push({
                    shopName: item.excludeShopKeeperNames && item.excludeShopKeeperNames.length ? item.excludeShopKeeperNames[inx] : '',
                    shopKeeperId: i
                })
            })
        }
        let goodsList = []
        if (item.includeGoodsIds) {
            item.includeGoodsIds.map((i, inx) => {
                goodsList.push({
                    goodsName: item.includeGoodsNames && item.includeGoodsNames.length ? item.includeGoodsNames[inx] : '',
                    id: i
                })
            })
        }
        let goodsLists = []
        if (item.excludeGoodsIds) {
            item.excludeGoodsIds.map((i, inx) => {
                goodsLists.push({
                    goodsName: item.excludeGoodsNames && item.excludeGoodsNames.length ? item.excludeGoodsNames[inx] : '',
                    id: i
                })
            })
        }
        let packageList = []
        if (item.includeGoodsItemIds) {
            item.includeGoodsItemIds.map((i, inx) => {
                packageList.push({
                    subTitle: item.includeGoodsItemNames && item.includeGoodsItemNames ? item.includeGoodsItemNames[inx] : '',
                    id: i
                })
            })
        }
        let packageLists = []
        if (item.excludeGoodsItemIds) {
            item.excludeGoodsItemIds.map((i, inx) => {
                packageLists.push({
                    subTitle: item.excludeGoodsItemNames && item.excludeGoodsItemNames.length ? item.excludeGoodsItemNames[inx] : '',
                    id: i
                })
            })
        }
        list.push({
            //商品类型
            goodsCategoryIds: item.goodsCategoryIds,
            // 城市
            cityNameArr: item.cityNameArr ? item.cityNameArr : [],
            excludeCityNameArr: item.excludeCityNameArr ? item.excludeCityNameArr : [],
            includeCityCodes: [],
            includeCityNames: [],
            excludeCityCodes: [],
            excludeCityNames: [],
            //门店类型
            includeSubCategoryCodes: item.includeSubCategoryCodes ? item.includeSubCategoryCodes : [],
            includeSubCategoryNames: item.includeSubCategoryNames ? item.includeSubCategoryNames : [],
            excludeSubCategoryCodes: item.excludeSubCategoryCodes ? item.excludeSubCategoryCodes : [],
            excludeSubCategoryNames: item.excludeSubCategoryNames ? item.excludeSubCategoryNames : [],
            //商家
            includeShopKeeperIds: item.includeShopKeeperIds ? item.includeShopKeeperIds : [],
            includeShopKeeperNames: item.includeShopKeeperNames ? item.includeShopKeeperNames : [],
            excludeShopKeeperIds: item.excludeShopKeeperIds ? item.excludeShopKeeperIds : [],
            excludeShopKeeperNames: item.excludeShopKeeperNames ? item.excludeShopKeeperNames : [],
            //商品
            includeGoodsIds: type == 'string' ? item.includeGoodsIds ? item.includeGoodsIds[0] : '' : item.includeGoodsIds ? item.includeGoodsIds : [],
            includeGoodsNames: item.includeGoodsNames ? item.includeGoodsNames : [],
            excludeGoodsIds: item.excludeGoodsIds ? item.excludeGoodsIds : [],
            excludeGoodsNames: item.excludeGoodsNames ? item.excludeGoodsNames : [],
            //套餐
            includeGoodsItemIds: type == 'string' ? item.includeGoodsItemIds ? item.includeGoodsItemIds[0] : '' : item.includeGoodsItemIds ? item.includeGoodsItemIds : [],
            includeGoodsItemNames: item.includeGoodsItemNames ? item.includeGoodsItemNames : [],
            excludeGoodsItemIds: item.excludeGoodsItemIds ? item.excludeGoodsItemIds : [],
            excludeGoodsItemNames: item.excludeGoodsItemNames ? item.excludeGoodsItemNames : [],
            shopKeeperList: shopKeeperList,//包含商家列表
            shopKeeperLists: shopKeeperLists,//不包含商家列表
            goodsList: goodsList,//包含商品列表
            goodsLists: goodsLists,//不包含商品列表
            packageList: packageList,//包含商品对应的套餐列表
            packageLists: packageLists,//不包含商品对应的套餐列表
            maxOriginPrice: item.maxOriginPrice / 100,
            minOriginPrice: item.minOriginPrice / 100,
        })
    })
    return list;
}

//获取字符串中的两个颜色值
export function getColor(obj) {
    let color1 = ''
    let color2 = ''
    if (obj) {
        const index1 = obj.indexOf('#')
        const index2 = obj.indexOf('#', index1 + 1)
        color1 = obj.substr(index1, 7)
        color2 = obj.substr(index2, 7)
    }
    return {
        color1,
        color2
    }
}
export function jdRuleData(list, id, array) {
    let myItems = []
    list.map(item => {
        let index = array.findIndex(a => item.origin.includeGoodsIds.indexOf(a.id) > -1)
        if (index > -1) {
            let goodsList = []
            let items = []
            goodsList.push({
                goodsName: item.redefineGoodsName ? item.redefineGoodsName : item.origin.includeGoodsNames.toString(),
                oldGoodsName: item.origin.includeGoodsNames.toString(),
                goodsId: item.origin.includeGoodsIds.toString()
            })
            if (id) {
                items.push({
                    costAmount: Number((item.costAmount / 100).toFixed(2)),
                    lockSettlePrice: item.lockSettlePrice,
                    oldSaleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
                    saleAmount: Number(((item.saleAmount ? item.saleAmount : item.origin.saleAmount) / 100).toFixed(2)),
                    settleAmount: Number((item.settleAmount / 100).toFixed(2)),
                    subTitle: item.redefineGoodsItemName ? item.redefineGoodsItemName : item.origin.includeGoodsItemNames.toString(),
                    oldSubTitle: item.origin.includeGoodsItemNames.toString(),
                    goodsItemId: item.origin.includeGoodsItemIds.toString(),
                    originId: item.originId,
                    id: item.id?item.id:'',
                    contract: item.contract,
                })
            } else {
                items.push({
                    costAmount: Number((item.origin.settleAmount / 100).toFixed(2)),
                    lockSettlePrice: false,
                    saleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
                    oldSaleAmount: Number((item.origin.saleAmount / 100).toFixed(2)),
                    settleAmount: '',
                    subTitle: item.redefineGoodsItemName ? item.redefineGoodsItemName : item.origin.includeGoodsItemNames.toString(),
                    goodsItemId: item.origin.includeGoodsItemIds.toString(),
                    originId: item.originId,
                    contract: item.contract,
                    id: item.id?item.id:'',
                })
            }
            myItems.push({
                goodsList,
                items,
            })
        }
    })
    var mianSetObj = {}
    // 找出 mianSetting 中的重复对象
    let mianSettings = myItems.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.goodsList[0].goodsId]) {
            mianSetObj[next.goodsList[0].goodsId] = true
            cur.push(next.goodsList[0].goodsId)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur
    }, [])
    mianSettings = mianSettings.map(item => {
        let items1 = []
        let goodsList1 = []
        myItems.map((set) => {
            if (item == set.goodsList[0].goodsId) {
                goodsList1 = set.goodsList
                items1.push({
                    costAmount: set.items[0].costAmount,
                    lockSettlePrice: set.items[0].lockSettlePrice,
                    oldSaleAmount: set.items[0].oldSaleAmount,
                    saleAmount: set.items[0].saleAmount,
                    settleAmount: set.items[0].settleAmount,
                    subTitle: set.items[0].subTitle,
                    oldSubTitle: set.items[0].oldSubTitle,
                    originId: set.items[0].originId,
                    goodsItemId: set.items[0].goodsItemId,
                    contract: set.items[0].contract,
                    id: set.items[0].id,
                })
            }
        })
        return {
            goodsList: goodsList1,
            items: items1
        }
    })
    console.log(mianSettings, 'mianSettings')
    return mianSettings
}

export function base64ToBlob(base64Data, contentType) {
    const blob = base64ToBlob(base64Data, contentType);
    const objectUrl = URL.createObjectURL(blob);
    return objectUrl;
}

// 时间戳转换方法    date:时间戳数字
export function format_redDate(date) {
  var date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  // + ss
  return YY + MM + DD + ' ' + hh + mm + ss
}


export function carRuleData(list, id) {
    let myItems = []
    list.map(item => {
        let goodsList = []
        let items = []
        let cityList = []
        goodsList.push({
            goodsName: item.goods.goodsName,
            goodsId: item.goodsId
        })
        if(item.includeCityCodes && item.includeCityNames){
            item.includeCityCodes.split(',').map((c,c_inx) =>{
                cityList.push({
                    cityName:item.includeCityNames.split(',')[c_inx],
                    cityCode:c,
                })
            })
        }
          items.push({
              originPrice: Number((item.goods.originPrice / 100).toFixed(2)),
              settlePrice: Number((item.goods.settlePrice / 100).toFixed(2)),
              salePrice: Number((item.goods.salePrice / 100).toFixed(2)),
              goodsId: item.goodsId,
              salePriceFloat: item.salePriceFloat?Number((item.salePriceFloat / 100).toFixed(2)):'',
              settlePriceFloat: item.settlePriceFloat?Number((item.settlePriceFloat / 100).toFixed(2)):'',
              oldSalePriceFloat: item.salePriceFloat?Number((item.salePriceFloat / 100).toFixed(2)):'',
              oldSettlePriceFloat: item.settlePriceFloat?Number((item.settlePriceFloat / 100).toFixed(2)):'',
              id: item.id,
              isCity: item.includeCityCodes?true:false,
              cityList: cityList,
              includeCityCodes: item.includeCityCodes ?item.includeCityCodes.split(','):[],
              includeCityNames: item.includeCityNames ?item.includeCityNames.split(','):[],
              originId: item.originId,
          })
        myItems.push({
            goodsList,
            items,
        })
    })
    var mianSetObj = {}
    // 找出 mianSetting 中的重复对象
    let mianSettings = myItems.reduce((cur, next) => {
        // 不重复的
        if (!mianSetObj[next.goodsList[0].goodsId]) {
            mianSetObj[next.goodsList[0].goodsId] = true
            cur.push(next.goodsList[0].goodsId)
        }
        // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
        return cur
    }, [])
    mianSettings = mianSettings.map(item => {
        let items1 = []
        let goodsList1 = []
        myItems.map((set) => {
            if (item == set.goodsList[0].goodsId) {
                goodsList1 = set.goodsList
                items1.push({
                    settlePrice: set.items[0].settlePrice,
                    salePrice: set.items[0].salePrice,
                    originPrice: set.items[0].originPrice,
                    salePriceFloat: set.items[0].salePriceFloat,
                    settlePriceFloat: set.items[0].settlePriceFloat,
                    oldSalePriceFloat: set.items[0].oldSalePriceFloat,
                    oldSettlePriceFloat: set.items[0].oldSettlePriceFloat,
                    goodsId: set.items[0].goodsId,
                    id: set.items[0].id,
                    originId: set.items[0].originId,
                    isCity: set.items[0].isCity,
                    cityList: set.items[0].cityList,
                    includeCityCodes: set.items[0].includeCityCodes,
                    includeCityNames: set.items[0].includeCityNames,
                })
            }
        })
        return {
            goodsList: goodsList1,
            items: items1
        }
    })
    console.log(mianSettings, 'mianSettings')
    return mianSettings
}

// 【点餐价格模板分解】
export function handlerMahuaRuleData(movieTicketSettingList, id) {
  const settingList = movieTicketSettingList.map(item => {
    return {
      // 城市、影院、影厅、电影、院线 设置为对象
      mianSetting: JSON.stringify({
        // 城市
        cityNameList: item.cityNameList,
        excludeCityNameList: item.excludeCityNameList,
        // 品牌
        brandNameList: item.brandNameList,
        excludeBrandNameList: item.excludeBrandNameList,
        // 店铺
        shopNameList: item.shopNameList,
        excludeShopNameList: item.excludeShopNameList

      }),
      // 利润区间
      minProfitAmount: item.minProfitAmount / 100,
      maxProfitAmount: item.maxProfitAmount / 100,
      // 品城卡价
      membershipPrice: item.membershipPrice ?item.membershipPrice / 100 : 0,
      salePrice: item.salePrice / 100,
      //  id
      mahuaPriceItemId: item.mahuaPriceItemId,
      originId: item.originId
    }
  })
  var mianSetObj = {}
  // 找出 mianSetting 中的重复对象
  let mianSettings = settingList.reduce((cur, next) => {
    // 不重复的
    if (!mianSetObj[next.mianSetting]) {
      mianSetObj[next.mianSetting] = true
      cur.push(next.mianSetting)
    }
    // 不会报错，也比较好懂了 （当对象里没有所传属性时，给属性true并PUSH数组）
    return cur
  }, [])

  // 设置值
  mianSettings = mianSettings.map(item => {
    const otherSettingData = []
    settingList.forEach(set => {
      if (item == set.mianSetting) {
        otherSettingData.push({
          // 价格区间
          minProfitAmount: set.minProfitAmount,
          maxProfitAmount: set.maxProfitAmount,
          // 品城卡价
          membershipPrice: set.membershipPrice,
          salePrice: set.salePrice,
          //  id
          mahuaPriceItemId: set.mahuaPriceItemId,
          originId: set.originId
        })
      }
    })
    return {
      mianSetting: JSON.parse(item),
      otherSettingData: otherSettingData
    }
  })
  console.log(mianSettings, 'mianSettings')
  return mianSettings
}

// 【点餐】
export function decomposeMahuaRuleData(mianSettings) {
  const sub_mahua_rule_data = []
  mianSettings.map(set => {
    // 循环价格的数据
    set.otherSettingData.forEach(other_set => {
      sub_mahua_rule_data.push({
        // 城市
        cityNameList: set.mianSetting.cityNameList,
        excludeCityNameList: set.mianSetting.excludeCityNameList,
        // 品牌
        brandNameList: set.mianSetting.brandNameList,
        excludeBrandNameList: set.mianSetting.excludeBrandNameList,
        // 店铺
        shopNameList: set.mianSetting.shopNameList,
        excludeShopNameList: set.mianSetting.excludeShopNameList,
        // 价格区间
        minProfitAmount: other_set.minProfitAmount * 100,
        maxProfitAmount: other_set.maxProfitAmount * 100,
        // 销售价
        salePrice: other_set.salePrice * 100,
        // 品城卡价
        membershipPrice: other_set.membershipPrice * 100,
        // 其他
        mahuaPriceItemId: other_set.mahuaPriceItemId,
        originId: other_set.originId
      })
    })
  })
  return sub_mahua_rule_data
}